import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Typography } from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import Button from "../Button/Button";

const filters = [
  "Any Day",
  "This week",
  "This weekend",
  "Next weekend",
  "Next week",
  "Custom",
];

export default function BottomCalenderModal({
  open,
  toggleDrawer,
  setSelectedWhen,
  whenToggle,
}) {
  const [calenderValue, setCalenderValue] = React.useState("");
  console.log(calenderValue, "calenderValue");
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: {
          height: "100%",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexFlow: "column",
          width: "100%",
          height: "100%",
          padding: "24px 16px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            marginBottom: "16px",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <ArrowBackIcon
            onClick={() => toggleDrawer(false)}
            sx={{
              fontSize: "24px",
              color: "primary.main",
              cursor: "pointer",
            }}
          />
          <Typography
            fontWeight="600"
            fontSize="16px"
            lineHeight="24px"
            color="text.primary"
            sx={{ textDecoration: "underline" }}
            //   onClick={clearAll}
          >
            Clear All
          </Typography>
        </Box>
        <Box
          sx={{
            marginTop: "101px",
            width: "328px !important",
            "& .PrivatePickersSlideTransition-root": {
              height: "auto",
            },
            "& .MuiCalendarPicker-root": {
              maxHeight: "auto",
            },
            "& .MuiPickerStaticWrapper-root, .MuiPickerStaticWrapper-root div":
              {
                overflow: "unset",
              },
            "& .MuiButtonBase-root.MuiPickersDay-root.MuiPickersDay-today": {
              backgroundColor: "#fff",
              border: "2px solid #255CCE",
              color: "text.primary",
            },
            "& .MuiButtonBase-root.MuiPickersDay-root.Mui-selected": {
              backgroundColor: "#255CCE",
              color: "#fff",
              borderTopLeftRadius: "50%",
              borderBottomLeftRadius: "50%",
            },
            "& .MuiButtonBase-root": {
              fontSize: "16px",
              lineHeight: "24px",
              width: "40px",
              height: "40px",
            },
            "& *": {
              fontSize: "16px",
              lineHeight: "24px",
            },
            "& .PrivatePickersSlideTransition-root > div div": {
              marginTop: "8px",
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              value={calenderValue}
              onChange={(newValue) => {
                setCalenderValue(newValue);
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            zIndex: "1000",
            position: "absolute",
            bottom: "0%",
            backgroundColor: "#fff",
            left: "0px",
          }}
        >
          <Button
            variant="contained"
            size="lg"
            txColor="text.primary"
            bgColor="#F9D548"
            sx={{
              margin: "16px",
              height: "48px",
              width: "343px",
              boxShadow: "none",
            }}
            onClick={() => {
              setSelectedWhen(calenderValue);
              whenToggle(false);
              toggleDrawer(false);
            }}
            hoverBg="#F3C04F"
          >
            Save
          </Button>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}
